// removed by extract-text-webpack-plugin
module.exports = {"App":"lBEXIWN5z0N5VPW0i1w00","withAudioGuidePlayer":"OzjDBdkli7U0RMoeHHS4g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/App.css
// module id = 246
// module chunks = 8